export default {
  accent: '#FF5F1F',
  textColor: '#e3dee8',
  borderColor: '#767478',
  blueAccent: '#0095ff',
  dark: '#010101',
}